export default [
  {
    title: "一行一个",
    type: "pOneLineOne", // 有一个oneLineOne了，在画布项目中拿这个做了全局组件注册
    iconName: "imgText-two-icon",
    iconActiveName: "imgText-two-active-icon"
  },
  {
    title: "轮播图",
    type: "carousel",
    iconName: "imgText-swipe-icon",
    iconActiveName: "imgText-swipe-active-icon"
  }
];



// WEBPACK FOOTER //
// ./src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/baseComponents/PictureAdvertising/typeOptions.js